import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { ReportToggleTypes } from '@consts/reports';
import { GraphViewActiveIcon, GraphViewIcon, TableViewActiveIcon, TableViewIcon } from '../assets';
import { useStyles } from './styles/Report.styles';

interface ToggleChartTypeProps {
    updateType: (type: ReportToggleTypes) => void;
    type: ReportToggleTypes;
}

export const ToggleChartType = ({ updateType, type }: ToggleChartTypeProps) => {
    const classes = useStyles();

    return (
        <ToggleButtonGroup
            value={type}
            onChange={(_, value) => {
                if (value) updateType(value as ReportToggleTypes);
            }}
            exclusive
            className={classes.toggleButton}>
            <ToggleButton value={ReportToggleTypes.ToggleChartType} size={'small'}>
                <Tooltip title='Chart View'>
                    <div className={classes.toggleIcon}>
                        {type === ReportToggleTypes.ToggleChartType ? <GraphViewActiveIcon /> : <GraphViewIcon />}
                    </div>
                </Tooltip>
            </ToggleButton>

            <ToggleButton value={ReportToggleTypes.ToggleTableType} size={'small'}>
                <Tooltip title='Table View'>
                    <div className={classes.toggleIcon}>
                        {type === ReportToggleTypes.ToggleTableType ? <TableViewActiveIcon /> : <TableViewIcon />}
                    </div>
                </Tooltip>
            </ToggleButton>
        </ToggleButtonGroup>
    );
};
